import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import ManageGrossRentsEmptyState from '../ManageGrossRentsEmptyState';
import parentMessages from '../messages';
import AddGrossRentLimitsWizard from '../AddGrossRentLimitsWizard';
import GrossRentChangeDrawer from './GrossRentChangeDrawer';
import useGrossRentChanges from './hooks';
import messages from './messages';

const tabContentSx = { mt: 3 };

const GrossRentChangesTab = () => {
  const [editingChange, setEditingChange] = useState(null);
  const {
    grossRentChanges,
    isLoading,
    isSuccess,
    isError,
    isRetrying,
    refetch,
  } = useGrossRentChanges();

  if (isLoading) {
    return (
      <AsyncBox
        loading
        sx={{
          ...tabContentSx,
          minHeight: 400,
        }}
      />
    );
  }

  if (isError) {
    return (
      <ManageGrossRentsEmptyState
        message={messages.loadError}
        retryMessage={messages.retry}
        onRetry={refetch}
        isRetrying={isRetrying}
        sx={tabContentSx}
      />
    );
  }

  if (isSuccess && grossRentChanges.length === 0) {
    return (
      <ManageGrossRentsEmptyState
        message={parentMessages.grossRentChangesEmptyState}
        sx={tabContentSx}
      />
    );
  }

  if (!isSuccess) {
    return null;
  }

  return (
    <Stack spacing={4} sx={tabContentSx}>
      <Typography variant="bodyMedium" color="text.secondary">
        <FormattedMessage {...messages.helperText} />
      </Typography>
      <div>
        {grossRentChanges.map((grossRentChange, index) => (
          <GrossRentChangeDrawer
            key={`${grossRentChange.effectiveDate}-${index}`}
            grossRentChange={grossRentChange}
            onEditChange={setEditingChange}
          />
        ))}
      </div>
      <AddGrossRentLimitsWizard
        open={Boolean(editingChange)}
        editingChange={editingChange}
        closeModal={() => setEditingChange(null)}
      />
    </Stack>
  );
};

export default GrossRentChangesTab;
